import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CustomProduct } from '@product/const';
import { DeviceService } from '@shared/services';
import { ProductCompactPriceComponent, ProductCompactTitleComponent } from '../../product-compact';
import { AddToCartComponent } from '../../product-page-add-to-cart';

@Component({
  selector: 'sd-product-availability-current-product',
  imports: [AddToCartComponent, ProductCompactTitleComponent, ProductCompactPriceComponent],
  templateUrl: './product-availability-current-product.component.html',
  styleUrls: ['./product-availability-current-product.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductAvailabilityCurrentProductComponent {
  private readonly deviceService = inject(DeviceService);

  protected readonly product = input.required<CustomProduct>();

  protected readonly isDesktopLgUp = toSignal(this.deviceService.isDesktopLgUp$, { initialValue: false });
}
